import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Alert, Stack, IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { performChangePassword } from '../controllers/authController';

const ChangePasswordDialog = ({ open, onClose }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [show, setShow] = useState({ cur: false, next: false, conf: false });

  const resetState = () => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setError('');
    setSuccess('');
    setSubmitting(false);
    setShow({ cur: false, next: false, conf: false });
  };

  const handleClose = () => {
    resetState();
    onClose?.();
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (newPassword !== confirmPassword) {
      setError('Yeni şifre ile doğrulama uyuşmuyor.');
      return;
    }
    setSubmitting(true);
    try {
      const ok = await performChangePassword({ currentPassword, newPassword, confirmPassword });
      if (ok) setSuccess('Şifre başarıyla değiştirildi.');
      setTimeout(handleClose, 1200);
    } catch (err) {
      setError(err?.message || 'Şifre değiştirilemedi');
    } finally {
      setSubmitting(false);
    }
  };

  const adornment = (key) => (
    <InputAdornment position="end">
      <IconButton onClick={() => setShow((s) => ({ ...s, [key]: !s[key] }))} edge="end" aria-label="görünürlük">
        {show[key] ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </InputAdornment>
  );

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs" PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle>Şifre Değiştir</DialogTitle>
      <form onSubmit={onSubmit}>
        <DialogContent>
          <Stack spacing={2}>
            {error && <Alert severity="error">{error}</Alert>}
            {success && <Alert severity="success">{success}</Alert>}
            <TextField label="Mevcut Şifre" type={show.cur ? 'text' : 'password'} value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required InputProps={{ endAdornment: adornment('cur') }} />
            <TextField label="Yeni Şifre" type={show.next ? 'text' : 'password'} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required InputProps={{ endAdornment: adornment('next') }} />
            <TextField label="Yeni Şifre (Tekrar)" type={show.conf ? 'text' : 'password'} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required InputProps={{ endAdornment: adornment('conf') }} />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={submitting}>İptal</Button>
          <Button type="submit" variant="contained" disabled={submitting}>Kaydet</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ChangePasswordDialog;


